import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { PhoneNumber } from "../../../../../../../components/forms/phone-number";
import { VerificationDTO } from "../../../../../../../store/verification/models/dto/due-diligence";

type FormType = VerificationDTO.Requests.DueDiligence.Form.Post.Final.T["kycRequests"][number];

export const Phone: FC<{}> = ({}) => {
  const { t } = useTranslation("fields");

  const {
    formState: { errors },
    getValues,
    setValue,
  } = useFormContext<FormType>();

  return (
    <PhoneNumber
      editing
      label={t("mobileNumber")}
      error={errors.mobileCountryCode?.message || errors.mobileNumber?.message}
      value={{
        phone: getValues().mobileNumber,
        prefix: getValues().mobileCountryCode,
      }}
      onChange={({ prefix, phone }) => {
        setValue("mobileNumber", phone || "", {
          shouldTouch: true,
          shouldDirty: true,
          shouldValidate: true,
        });
        setValue("mobileCountryCode", prefix ? `+${prefix}` : "", {
          shouldTouch: true,
          shouldDirty: true,
          shouldValidate: true,
        });
      }}
    />
  );
};
